import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import type { FullContest } from '@betterpool/api-types/contests-service';

import { ButtonLink } from '~/domains/design-system/Button';
import { Routes } from '~/domains/common/constants/routes';
import dt from '~/testing';

interface ManageContestButtonProps {
  className?: string;
  contest: FullContest;
  isHidden?: boolean;
}

function ManageContestButton({ className, contest, isHidden }: ManageContestButtonProps) {
  const { t } = useTranslation('contest');

  if (isHidden) {
    return null;
  }

  return (
    <ButtonLink
      variant="tertiary-fill"
      size="medium"
      className={className}
      data-test-id={dt.contestDetail.page.header.actions.manage}
      href={Routes.manageContest(contest.id)}
    >
      {t('detail.header.actions.manage')}
    </ButtonLink>
  );
}

export default ManageContestButton;
